<mat-card style="width: 100%;">
  <mat-card-header>
    <mat-card-title class="header-style">Audit Trail</mat-card-title>
  </mat-card-header>
  <app-audit-trail-table [module]="''"></app-audit-trail-table>
</mat-card>